import React from 'react';
import { number, string } from 'prop-types';
import { getLucideIconUrl } from '../../config/iconSystem';

function SystemIcon({
  icon,
  size = 18,
  alt = '',
  tone = 'light',
}) {
  const filter = tone === 'red'
    ? 'invert(18%) sepia(91%) saturate(7454%) hue-rotate(348deg) brightness(93%) contrast(114%)'
    : 'invert(100%)';

  return (
    <img
      src={getLucideIconUrl(icon)}
      alt={alt}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        display: 'inline-block',
        objectFit: 'contain',
        filter,
        opacity: tone === 'muted' ? 0.75 : 1,
      }}
      loading="lazy"
      decoding="async"
    />
  );
}

SystemIcon.propTypes = {
  icon: string.isRequired,
  size: number,
  alt: string,
  tone: string,
};

export default SystemIcon;
